import {IParams, ICollection, RecursosController} from "../recursos";
import {EventManager} from "./event-manager";

declare global {
    interface Window {
        dailymotion: any;
        subtipologia: string;
        listaKeyValuesTexto: string;
    }
}

export class DailymotionController extends RecursosController {

    /* INSTANCE */
    private readonly dmPlayers: ICollection;
    public static instance: DailymotionController;

    /* STATIC */
    public static override async build(): Promise<void> {
        DailymotionController.instance = new this();
        RecursosController.instances.push(DailymotionController.instance);
    }

    constructor() {
        super();
        this.dmPlayers = {};
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='dailymotion-head'], [class*='dailymotion-body'], [class='dailymotion-live'], [class='dailymotion-video-bottom']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement): Promise<void> {
        if (!this.dmPlayers[item.id]) {
            if (!window.hbError) {
                const eventId = "prerollKv" + item.id;
                const em = EventManager.build();
                em.addId(eventId);

                const listener = (e: Event) => {
                    const customEvent = e as CustomEvent;
                    if (customEvent.detail) {
                        this.loadVideo(item, customEvent.detail?.kv);
                    }
                    document.removeEventListener(eventId, listener);
                };

                document.addEventListener(eventId, listener, { once: true });

                window.alpred.hb.refreshById(["preroll"]);
            } else {
                this.loadVideo(item);
            }
        }
    }

    protected async loadVideo(item: HTMLElement, kvPrebid: string = ""): Promise<void> {
        if (!this.dmPlayers[item.id]) {
            const params = JSON.parse(item.getAttribute('data-lazy')!.replace(/'/g,"\""));
            const id = item.id;
            const clase = item.className;
            const urls: IParams[] = [{name: "script-dailymotion-" + params.player, value: "https://geo.dailymotion.com/libs/player/" + params.player + ".js"}];
            const promesas = await this.initPromises(urls);

            await Promise.all(promesas).then(async()=>{
                const config: any = {
                    params: {
                        customConfig: {
                            dynamiciu: "/151127700/video",
                            keyvalues: 'subtipologia=' + window.subtipologia + '&position=' + params.position + (kvPrebid.length > 0 ? kvPrebid : ''),
                            plcmt: 2
                        }
                    }
                };
                if (params.playlist) {
                    config.playlist = params.playlist;
                } else {
                    config.video = params.video;
                }
                config.player = params.player;
                config.mute = true;

                await window.dailymotion.createPlayer(id, config).then((player: any) => {
                    this.dmPlayers[id] = player;
                }).catch(function (e: any) {
                    console.error(e);
                });
            });
        }
    }

}
